/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const FILTER_LABEL: Record<string, string> = {
  waste: "Estate Records with Savings Suggestions",
  unassigned: "Unallocated Estate Records",
  enrichment: "Enriched Estate Records",
  co2eWaste: "Estate Records with Carbon Emissions Savings",
};
